// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".server-error-enter-active[data-v-22a9e1c3],.server-error-leave-active[data-v-22a9e1c3]{transition:transform .4s cubic-bezier(0,0,.3,1)}.server-error-enter[data-v-22a9e1c3],.server-error-leave-to[data-v-22a9e1c3]{transform:scale(.2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
